import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      padding: rem(8),
      borderRadius: rem(12),
      backgroundColor: theme.colors.neutral[0],
      border: `1px solid ${theme.colors.gray[1]}`,
      display: 'flex',
      [theme.fn.smallerThan('sm')]: {
        flexDirection: 'column',
      },
      [theme.fn.largerThan('sm')]: {
        gap: rem(24),
      },
    },
    thumbnail: {
      backgroundColor: theme.colors.green[0],
      borderRadius: rem(8),
      [theme.fn.largerThan('sm')]: {
        width: rem(192),
        flexShrink: 0,
      },
    },
    thumbnailImg: {
      borderRadius: 'inherit',
    },
    info: {
      display: 'flex',
      flexDirection: 'column',
      gap: rem(4),
      textAlign: 'left',
      [theme.fn.smallerThan('sm')]: {
        padding: `${rem(16)} ${rem(8)}`,
      },
      [theme.fn.largerThan('sm')]: {
        padding: `${rem(8)} 0`,
      },
    },
    btn: {
      padding: 0,
      height: rem(22),
      '&,&:hover': {
        backgroundColor: 'transparent',
        color: theme.fn.primaryColor(),
      },
    },
    btnIcon: {
      marginTop: rem(1),
    },
  }
})
